export default {"src":"/_next/static/media/ic-star-rating.912706c8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};